module.exports = "./swagger-icon.svg